<template lang="pug">
#banner-noticias(v-if="usuarioLogado.paisGrupo === ambientes.PARAGUAY" v-loading='carregando', style='height: 100%')
    .lyra__cartao__fixo
        img(src='../../assets/banner-lyra/banner_lyra.png', alt='Banner Lyra', class="banner-lyra-img")
        .texto-centralizado
            h1 {{ $t('mensagens.home.bannerFixo.titulo') }}
            h2 {{ $t('mensagens.home.bannerFixo.subtitulo') }}
        
#banner-noticias(v-else v-loading='carregando', style='height: 100%')
    h3 {{ $t('mensagens.home.noticias.titulo') }}
    .lyra__cartao
        el-carousel(height='170px', arrow='never', :interval='7000')
            el-carousel-item(
                v-for='(noticia, index) in noticias',
                :key='index',
                :style='`background-image: linear-gradient(to left, transparent, var(--primary)), url(${noticia.imagem})`'
            )
                a.banner-noticias__informacoes(
                    :href='noticia.link',
                    target='_blank'
                )
                    h2 {{ noticia.titulo }}
                    h3 {{ noticia.descricao }}
                    p.banner-noticias__data {{ noticia.dataCadastroFormatada }}
</template>

<script>
import NoticiasService from '@/services/NoticiasService';
import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'BannerNoticias',

    mounted() {
        this.buscarNoticias();
    },

    data() {
        return {
            noticias: [],
            carregando: true,
            ambientes: AmbientesEmpresas
        };
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    methods: {
        async buscarNoticias() {
            this.carregando = true;
            try {
                const { data } = await NoticiasService.buscarNoticias();
                this.noticias = data;

                if (!this.noticias.length) {
                    this.noticias.push({
                        titulo: this.$t('mensagens.home.noticias.naoHaNoticias'),
                        decricao: '',
                        link: '',
                        ativo: true,
                        dataCadastroFormatada: '',
                        imagem: ''
                    });
                }
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.home.noticias.erro')
                });
            } finally {
                this.carregando = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.lyra__cartao {
    height: 100%;
    overflow: hidden;
}

.lyra__cartao__fixo {
    position: relative;
    text-align: start;
    height: 100%;
}

.banner-lyra-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
}

.texto-centralizado {
    position: absolute;
    top: 50%;
    left: 25%;
    transform: translate(-50%, -50%);
    color: white;
}

.banner-noticias__informacoes {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: inherit;
}
</style>

<style lang="scss">
#banner-noticias {
    h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }
    .el-carousel__item {
        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;
        color: var(--white) !important;
        padding: 15px 10px 20px 10px;

        h2 {
            font-size: 30px;
            font-weight: 500;
            margin-bottom: 6px;
            word-break: break-word;
            text-align: left;
        }

        h3 {
            font-weight: 500;
            margin-bottom: 15px;
            text-align: left;
        }
    }
    & > h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }

    .el-carousel__button {
        width: 10px !important;
        height: 10px !important;
        border-radius: 5px !important;
        margin: 0px 0px 0px 1px;
    }

    .is-active > .el-carousel__button {
        background-color: var(--secondary) !important;
    }

    .el-carousel__indicators--horizontal {
        bottom: 5px !important;
        left: 20px !important;
        -webkit-transform: none !important;
        transform: none !important;
    }

    a {
        color: var(--white) !important;
        text-decoration: none !important;
    }
}
</style>
